import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_3 = {
  key: 3,
  class: "mb-3 mt-4"
}
const _hoisted_4 = { class: "w-100 form-label" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChoiceControl = _resolveComponent("ChoiceControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasIcons())
      ? (_openBlock(), _createBlock(_component_ChoiceControl, {
          key: 0,
          value: _ctx.selectedValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedValue = $event)),
          options: _ctx.selectOptions,
          icons: _ctx.icons
        }, null, 8, ["value", "options", "icons"]))
      : _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 1,
          class: _normalizeClass(["form-select custom-select", {'is-invalid': _ctx.isInvalid()}]),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValue) = $event))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(option.label), 9, _hoisted_1))
          }), 256))
        ], 2)), [
          [_vModelSelect, _ctx.selectedValue]
        ]),
    (_ctx.isInvalid() && _ctx.selectedValue === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('form.errors.enumNotSelected')), 1))
      : _createCommentVNode("", true),
    (_ctx.isCustomValueOptionSelected())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('form.labels.customEnumValue')) + " ", 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.isInvalid()}]),
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customValue) = $event)),
              placeholder: _ctx.$t(`parameters.${_ctx.parameterId}.customValuePlaceholder`)
            }, null, 10, _hoisted_5), [
              [_vModelText, _ctx.customValue]
            ]),
            (_ctx.isInvalid() && _ctx.customValue.trim() === '')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('form.errors.customEnumValueIsBlank')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}